export default __webpack_public_path__ + "static/img-project-5-26723ff661d2ca8fea333e5bd65e8123.png";